import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import type { GetCategoryDataFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetCategoryDataFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetCategoryDataFragmentFragmentDoc';

/* GraphQL */ `
  fragment GetCategoryDataFragment on Breadcrumb {
    breadCrumb {
      name
      id
    }
  }
`;

export type GetCategoryDataProps =
  | FragmentType<typeof GetCategoryDataFragmentFragmentDoc>
  | undefined
  | null;

export const getCategoryData = (data: GetCategoryDataProps) => {
  const result: {
    categoryPath: NonNullable<GetCategoryDataFragmentFragment['breadCrumb']>;
    categoryPathAsString: string | undefined;
  } = {
    categoryPath: [],
    categoryPathAsString: undefined,
  };

  if (!data) return result;

  const { breadCrumb } = getFragmentData(GetCategoryDataFragmentFragmentDoc, data);

  if (breadCrumb === null) return result;

  result.categoryPath = breadCrumb;
  result.categoryPathAsString = breadCrumb.map((pathItem) => pathItem.name).join('/');

  return result;
};
